import DestacatNoticiaAutor from './DestacatNoticiaAutor';
import DestacatNoticiaAutorSkeleton from './DestacatNoticiaAutorSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatNoticiaAutorSkeleton /> : <DestacatNoticiaAutor {...props} />;
}
